import React, { useRef, useEffect } from 'react';
import { PlayCircle, StopCircle } from "@geist-ui/icons";
import { useLocation } from 'react-router-dom';
import { useAudio } from '../context/AudioContext';
import './BackgroundMusic.css';

const BackgroundMusic = () => {
  // Use the audio context
  const { 
    isBackgroundMusicPlaying, 
    backgroundMusicVolume, 
    setIsBackgroundMusicPlaying
  } = useAudio();
  
  const audioRef = useRef(null);
  const location = useLocation();
  
  // Don't show on landing page
  const showMusic = location.pathname !== '/';

  useEffect(() => {
    // Create audio element
    audioRef.current = new Audio('https://om-assets.fra1.cdn.digitaloceanspaces.com/assets/audio/background_music/The%20Wolves%20of%20Langston%20Ambient%20(mp3,%20Loopable).mp3');
    audioRef.current.loop = true;
    audioRef.current.volume = backgroundMusicVolume;
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        setIsBackgroundMusicPlaying(false);
      }
    };
  }, [backgroundMusicVolume, setIsBackgroundMusicPlaying]);

  // Sync audio playback with state
  useEffect(() => {
    if (!audioRef.current) return;
    
    if (isBackgroundMusicPlaying) {
      audioRef.current.play().catch(err => {
        console.error("Error playing audio:", err);
        setIsBackgroundMusicPlaying(false);
      });
    } else {
      audioRef.current.pause();
    }
  }, [isBackgroundMusicPlaying, setIsBackgroundMusicPlaying]);

  // Update volume when it changes in settings
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = backgroundMusicVolume;
    }
  }, [backgroundMusicVolume]);

  const toggleMusic = () => {
    // Direct state update instead of using contextToggleMusic
    setIsBackgroundMusicPlaying(!isBackgroundMusicPlaying);
  };

  if (!showMusic) return null;

  return (
    <button 
      className="bg-music-button"
      onClick={toggleMusic}
      title={isBackgroundMusicPlaying ? "Stop Background Music" : "Play Background Music"}
      aria-label={isBackgroundMusicPlaying ? "Stop Background Music" : "Play Background Music"}
    >
      {isBackgroundMusicPlaying ? <StopCircle size={24} /> : <PlayCircle size={24} />}
    </button>
  );
};

export default BackgroundMusic;